var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 72,
    viewBox: "0 0 2 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0C0.7 1.1838 0.6525 2.36761 0.6075 3.55141C0.2025 14.2056 0 24.8599 0 35.5141C0 46.1683 0.2025 56.8225 0.6075 67.4768C0.6525 68.6606 0.7 69.8444 0.75 71.0282C0.8 69.8444 0.8475 68.6606 0.8925 67.4768C1.2975 56.8225 1.5 46.1683 1.5 35.5141C1.5 24.8599 1.2975 14.2056 0.8925 3.55141C0.8475 2.36761 0.8 1.1838 0.75 0Z",
    fill: "#AC2B1F",
    fillOpacity: 0.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinered);
export default __webpack_public_path__ + "static/media/linered.0eec6765fa56403e9642628fefd2542c.svg";
export { ForwardRef as ReactComponent };